import { useSelector } from 'react-redux';

/**
 * Hook to check permissions against the Redux store.
 */
export const useAuthorization = () => {

  const permissions = useSelector((state) => state.permissions.value) || [];

  /**
   * Checks if a permission string exists in the Redux permission array.
   * @param {string} permissionKey
   * @returns {boolean}
   */
  const can = (permissionKey) => {
    return permissions.includes(permissionKey);
  };

  /**
   * Checks if the user has ANY of the provided permissions.
   * Useful for tabs or sections that require multiple roles.
   */
  const canAny = (permissionKeys = []) => {
    return permissionKeys.some(key => permissions.includes(key));
  };

  return {
    can,
    canAny,
    allPermissions: permissions
  };
};